import OliverText from "@builder/components/general/OliverText";
import "./style.scss";


const OneStepSVG = ({ color }: { color: string }) => <svg width="24" height="4" viewBox="0 0 24 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="4" rx="1" fill={color} />
</svg>


export const ProgressBar = ({ currentStepIdx, totalSteps }: { currentStepIdx: number, totalSteps: number }) => {
    
    return <div className="progress-bar">
        <div className="progress-bar-steps">

    {
        Array.from({ length: totalSteps }).map((_, index) => (
            <div key={index} className="progress-bar-step">
                <OneStepSVG color={index <= currentStepIdx ? "#2797E8" : "#E5E0EB"} />
            </div>
        ))
    }
    </div>
    <OliverText text={`Step ${currentStepIdx + 1} of ${totalSteps}`} size="xxs"  />
    </div>
};
